<template>
  <div class="course-page">
    <div class="course-main-lists">
      <div class="course-list-panel scrollbar">
        <template v-if="mainCourseList.length > 0">
          <a-collapse accordion v-model="activeKey">
            <a-collapse-panel
              v-for="mainCourseItem in mainCourseList"
              :key="'main_' + mainCourseItem.id"
            >
              <template slot="header">
                {{ mainCourseItem.title
                }}<span class="color-gray"
                  >({{ mainCourseItem.sectonDescript }})</span
                >
              </template>

              <div class="section-panel">
                <div
                  class="section-item"
                  v-for="sectionItem in mainCourseItem.section"
                  :key="sectionItem.id"
                >
                  <div class="section-item-title">{{ sectionItem.title }}</div>
                  <div class="node-panel">
                    <div
                      class="node-item"
                      :class="
                        nowNode && nowNode.id === nodeItem.id ? 'active' : ''
                      "
                      v-for="nodeItem in sectionItem.children"
                      :key="nodeItem.id"
                      @click="setPlay(nodeItem, mainCourseItem)"
                    >
                      <div class="node-item-play">
                        <a-icon type="play-circle" theme="filled" />
                      </div>
                      <div class="node-item-title">{{ nodeItem.title }}</div>
                      <div class="node-item-time">
                        {{ nodeItem.timelen | formatTime }}
                        <template v-if="1 === nodeItem.state">
                          <span class="color-green"
                            ><a-icon type="check" />已学习</span
                          >
                        </template>
                        <template v-else-if="nodeItem.progress > 0">
                          <span class="color-blue"
                            ><a-icon type="clock-circle" />学习中</span
                          >
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </template>
      </div>
    </div>

    <div class="player-panel">
      <div :id="player" class="dplayer course-player"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.dplayer {
  width: 100%;
  height: 400px;
}
.section-item {
  padding-bottom: 12px;
  .section-item-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    padding-bottom: 12px;
  }
  .node-panel {
    padding-left: 12px;
    .node-item {
      cursor: pointer;
      display: flex;
      border-bottom: 1px solid #fff;
      .node-item-play {
        width: 20px;
        flex-shrink: 0;
      }
      .node-item-title {
        font-size: 14px;
        flex: 1;
      }
      .node-item-time {
        padding-left: 24px;
        flex-shrink: 0;
        text-align: right;
        color: #8799a3;
        span {
          padding-left: 12px;
        }
      }
      .node-item-state {
        width: 100px;
        flex-shrink: 0;
        text-align: right;
      }
      &:hover {
        color: #1cbbb4;
        border-color: #1cbbb4;
        .node-item-time {
          color: #1cbbb4;
        }
      }
    }
    .active {
      color: #0081ff;
      .node-item-time {
        color: #0081ff;
      }
    }
  }
}

.course-page {
  display: flex;
  height: 100%;
  .course-main-lists {
    width: 35%;
    height: calc(100vh - 260px);
    flex-shrink: 0;
    .course-list-panel {
      height: calc(100% - 60px);
      padding-right: 24px;
    }
  }
  .player-panel {
    flex: 1;
    padding-left: 24px;
  }
}
</style>

<script>
import DPlayer from "dplayer";
export default {
  props: {
    planId: {
      type: Number,
      default: 0,
    },
    pwid: {
      type: Number,
      default: 0,
    },
    workId: {
      type: Number,
      default: 0,
    },
    courseType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      mainCourseList: [],
      childCourseList: [],
      activeKey: "0",
      dp: null,
      player: "play_" + new Date().getTime(),
      nowNode: null, //当前播放的小节
      nowCourse: null,
      progress: 0,
      timer: null,
    };
  },
  watch: {
    pwid() {
      this.getCourseList();
      this.initDplayer();
    },
    progress(now) {
      if (now > 0) {
        this.courseLog(now);
      }
    },
  },
  created() {
    this.getCourseList();
  },
  filters: {
    formatTime(second) {
      let h = Math.floor(second / 3600);

      let m = Math.floor((second - 3600 * h) / 60);

      let s = second - h * 3600 - 60 * m;

      return (h > 0 ? `${h}时` : "") + (m > 0 ? `${m}分` : "") + `${s}秒`;
    },
  },
  mounted() {
    this.initDplayer();
  },
  methods: {
    courseLog(progress) {
      this.nowNode.progress = progress;
      let time = new Date().getTime();
      this.$request.common.learn
        .courselog({
          id: time,
          pwid: this.pwid,
          planid: this.planId,
          workid: this.workId,
          action: "success",
          userid: this.$store.get("userid", 0),
          sectionid: this.nowNode.id,
          seetime: time,
          progress: progress,
        })
        .then(({ data }) => {
          console.log(data);
        });
    },
    //观看录播
    setPlay(item, course) {
      this.nowNode = item;
      this.nowCourse = course;
      this.courseId = item.id;
      this.progress = 0;

      if (null !== this.dp) {
        this.dp.destroy();
      }

      this.dp = new DPlayer({
        container: document.getElementById(this.player),
        autoplay: true,
        hotkey: false,
        screenshot: false, //截图
        video: {
          url: item.video,
          pic: "http://szn.sznykt.com/static/img/player.jpg",
        },
      });

      if (item.progress > 0) {
        this.dp.seek(item.progress / 1000);
      }

      this.bindAction();
    },

    bindAction() {
      let time = new Date().getTime();
      this.dp.on("ended", () => {
        let params = {
          id: time,
          pwid: this.pwid,
          userid: this.$store.get("userid", 0),
          planid: this.planId,
          workid: this.workId,
          courseid: this.nowCourse.id,
          sectionid: this.nowNode.id,
          currentTime: time,
        };

        this.$request.common.learn.course(params).then(({ data }) => {
          this.nowNode.state=1
          setTimeout(this.autoNext(), 5000);
        });

        
      });

      this.dp.on("playing", () => {
        //开始播放
        this.startTimer();
      });

      this.dp.on("waiting", () => {
        this.endTimer();
      });
      this.dp.on("pause", () => {
        this.endTimer();
      });
    },

    autoNext() {
      let len = this.nowCourse.section.length,
        rt = false,
        gonext = true;

      for (let i = 0; i < len; i++) {
        if (gonext) {
          let clen = this.nowCourse.section[i].children.length;
          for (let n = 0; n < clen; n++) {
            if (rt) {
              this.setPlay(
                this.nowCourse.section[i].children[n],
                this.nowCourse
              );
          
              gonext = false;
              break;
            } else if (
              this.nowCourse.section[i].children[n].id === this.nowNode.id
            ) {
              rt = true;
            } else {
              rt = false;
            }
          }
        } else {
          break;
        }
      }
    },

    //初始化定时器
    startTimer() {
      this.timer = setInterval(() => {
        this.progress = Math.floor(this.dp.video.currentTime * 1000);
      }, 10000);
    },
    //停止定时器
    endTimer() {
      if (null !== this.timer) {
        clearInterval(this.timer);
      }
    },

    initDplayer() {
      console.log("init dplayer");
      this.dp = new DPlayer({
        container: document.getElementById(this.player),
        hotkey: false,
        video: {
          url: "",
          pic: "http://szn.sznykt.com/static/img/player.jpg",
        },
      });
    },
    getCourseList() {
      this.$request.common.user
        .course({
          type: this.courseType,
          userid: this.$store.get("userid", 0),
          workid: this.workId,
          pwid:this.pwid
        })
        .then(({ data }) => {
          if (0 === data.errcode) {
            if (data.data.items.length > 0) {
              this.activeKey = "main_" + data.data.items[0].id;
              data.data.items.forEach((item) => {
                this.getCourseDetails(item.id);
              });
            } else {
              this.mainCourseList = [];
            }
          }
        });
    },
    getCourseDetails(id) {
      this.$request.common.course
        .details({
          id: id,
          userid: this.$store.get("userid", 0),
          workid: this.workId,
          pwid: this.pwid,
        })
        .then(({ data }) => {
          if (0 === data.errcode) {
            this.mainCourseList.push(data.data);
          }
        });
    },
  },
};
</script>